import { createContext, useEffect, useState, type ReactNode } from 'react';
import type { User } from 'firebase/auth';
import { onAuthChange } from '@/lib/firebase/auth';

export interface AuthContextValue {
  user: User | null;
  loading: boolean;
  isAllowedUser: boolean;
}

export const AuthContext = createContext<AuthContextValue>({
  user: null,
  loading: true,
  isAllowedUser: false,
});

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthChange((u) => {
      setUser(u);
      setLoading(false);
    });
    return unsub;
  }, []);

  const isAllowedUser = user !== null && (user.email?.endsWith('@seytravel.com') ?? false);

  return (
    <AuthContext.Provider value={{ user, loading, isAllowedUser }}>
      {children}
    </AuthContext.Provider>
  );
}
